<template>
  <section class="clearPa">
    <section class="tablePage left">
      <!-- 表格 -->
      <section class="tableBox">
        <el-radio-group v-model="tableData.chooseRadio">
          <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
            height="450"
          >
            <!-- 选择框 -->
            <el-table-column v-if="!isRadio" type="selection" width="55" />
            <!-- 选择框 end -->
            <el-table-column v-if="isRadio" width="55" label="选择">
              <template slot-scope="scope">
                <el-radio :label="scope.row[tableData.selectTar]">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
            />
          </el-table>
        </el-radio-group>
      </section>
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
    </section>
    <section class="left selectBox">
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          :data="tableData.selectResult"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
          height="450"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <el-table-column width="55" label="操作">
            <template slot-scope="scope">
              <span class="cur blur" @click="del(scope.row)"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </section>
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  roleList,
} from 'api/system';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: 'roleId',
        chooseRadio: '', // 单选选择
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'roleName',
            label: '角色名称',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: roleList,
    del (item) {
      this.tableData.selectResult.splice(this.tableData.selectResult.indexOf(item), 1);
      this.handleDefaultSelect();
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
.tablePage{
  width: 50%;
  padding-right: 8px;
  box-sizing: border-box;
  .tableBox{
    border-top: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
  }
  ::v-deep .el-table__header-wrapper{
    background: #e0e0e0;
  }
}
.selectBox{
  width: 50%;
  padding-left: 8px;
  box-sizing: border-box;
  .tableBox{
    border-top: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
  }
}
</style>
